import axios from "axios";
import _ from "lodash";
import { REFINERY_ID, DIRECT_TREE_TYPE } from "@/constant";
import { REFINERY_COLORS } from "@/constant/colors";
import Endpoint from "../../constant/endpoint";
import moment from "moment";

const state = {
  loading: false,
  error: {},
  data: [],
  dataVolume: [],
  barValueData: 0,
  vesselID: [],
  currentRefineryID: "",
  currentRefineryName: "ALL",
  oilType: [],
  dataByDate: [],
  notificationData: [],
  mpTankerLog: [],
};

const getters = {
  getterNewData: (state, getters) => {
    const sun = _.chain(state.data)
      .groupBy("station_id")
      .map((o, i) => {
        const name = _.findKey(REFINERY_ID, (val) => val == i) || "OTHER";
        const colors = REFINERY_COLORS[name] || "OTHER";
        return {
          id: i,
          name,
          colors,
          type: "Refinery",
          value: _.reduce(
            o,
            (sum, a) => {
              let volumes = _.get(a, "volumes").map((a) => {
                return Number(a);
              });
              return sum + _.sum(volumes);
            },
            0
          ),
          children: _.chain(o)
            .groupBy("vessel_id")
            .map((a, i) => {
              const mmsi = _.get(_.find(a, "vessel.mmsi"), "vessel.mmsi");
              const vessel = _.get(_.find(a, "vessel"), "vessel");
              const mpLogs = getters.getTankerbyMMSI(mmsi);
              let children = [];
              if (!_.isUndefined(mpLogs)) {
                const mpData = getters.getTransferLogs(mpLogs.id);
                children = _.map(mpData, (c) => {
                  return {
                    id: c.tanker_id,
                    name: c.tanker_name,
                    value: c.volume,
                    mmsi: c.mmsi,
                    type: DIRECT_TREE_TYPE.VESSEL,
                    transfer_date: c.transfer_date,
                  };
                });
              }

              return {
                id: i,
                name: _.get(_.find(a, "vessel.name"), "vessel.name"),
                type: "Tanker",
                mmsi,
                transfer_date: _.get(
                  _.find(children, "transfer_date"),
                  "transfer_date"
                ),
                vessel,
                children,
                value: _.reduce(
                  a,
                  (sum, a) => {
                    let volumes = _.get(a, "volumes").map((a) => {
                      return Number(a);
                    });
                    return sum + _.sum(volumes);
                  },
                  0
                ),
              };
            })
            .value(),
        };
      })
      .value();
    return sun;
  },
  getterVesselDemExp: (state) => {
    const sun = _.chain(state.data)
      .groupBy("station_id")
      .map((o, i) => {
        const name = _.findKey(REFINERY_ID, (val) => val == i) || "OTHER";
        const colors = REFINERY_COLORS[name] || "OTHER";
        return {
          id: i,
          name,
          colors,
          type: "Refinery",
          value: _.reduce(
            o,
            (sum, a) => {
              let volumes = _.get(a, "volumes").map((a) => {
                return Number(a);
              });
              return sum + _.sum(volumes);
            },
            0
          ),
          children: _.chain(o)
            .groupBy("vessel_id")
            .map((a, i) => {
              return {
                id: i,
                name: _.get(_.find(a, "vessel.name"), "vessel.name"),
                vessel: _.get(_.find(a, "vessel"), "vessel"),
                type: "Tanker",
                value: _.reduce(
                  a,
                  (sum, a) => {
                    let volumes = _.get(a, "volumes").map((a) => {
                      return Number(a);
                    });
                    return sum + _.sum(volumes);
                  },
                  0
                ),
              };
            })
            .value(),
        };
      })
      .value();
    return sun;
  },
  getterAllDirectData: (state) => {
    const tree = _.chain(state.data)
      .groupBy("station_id")
      .map((o, i) => {
        const name = _.findKey(REFINERY_ID, (val) => val == i) || "OTHER";
        const colors = REFINERY_COLORS[name] || "OTHER";
        return {
          id: i,
          name,
          colors,
          type: "Refinery",
          value: _.reduce(
            o,
            (sum, a) => {
              let volumes = _.get(a, "volumes").map((a) => {
                return Number(a);
              });
              return sum + _.sum(volumes);
            },
            0
          ),
          children: _.map(o, (a) => {
            // const value = Number(
            //   _.get(a, "volume", 0).replace(/[^0-9.-]+/g, "")
            // );
            return {
              id: a.vessel.id,
              name: a.vessel.name,
              vessel: {
                ...a.vessel,
              },
              value: _.reduce(
                o,
                (sum, a) => {
                  let volumes = _.get(a, "volumes").map((a) => {
                    return Number(a);
                  });
                  return sum + _.sum(volumes);
                },
                0
              ),
              type: "Tanker",
            };
          }),
        };
      })
      .value();
    return tree;
  },
  getStationValues: (state) => (id = "") => {
    return state.dataVolume
      .filter((value) => {
        if (id == "") {
          return true;
        } else if (value.station_id == id) {
          return true;
        }
      })
      .reduce((previous, current) => {
        let volumes = _.get(current, "volumes").map((a) => {
          return Number(a);
        });
        return previous + _.sum(volumes);
      }, 0);
  },
  getStationData: (state) => (id = "") => {
    let data = _.find(state.data, (o) => {
      return o.station_id == id;
    });
    return data;
  },
  getStationDataByDate: (state) => (id = "", date = "") => {
    let data = _.get(state.data[0], {
      station_id: id,
      departed_at_formatted_be: date,
    });
    return data;
  },
  getterOilTypeData: (state) => {
    return state.oilType;
  },
  getterStationDataByDate: (state) => {
    return state.dataByDate;
  },
  getterNotificationData: (state) => {
    return state.notificationData;
  },
};

const actions = {
  setVolume(context, value) {
    context.commit("SET_DATA_VOLUME", value);
  },
  setBarValue(context, value) {
    context.commit("SET_BAR_VOLUME", value);
  },
  setCurrentRefName(context, refName) {
    context.commit("SET_CURRENT_REFINERY_NAME", refName);
  },
  setCurrentRefID(context, refID) {
    context.commit("SET_CURRENT_REFINERY_ID", refID);
  },
  async getVesselVolume(context, data) {
    context.commit("LOADING_VESSEL_TRIP", { loading: true });
    const config = {
      params: {
        "q[departed_at_gt]": data.startDate,
        "q[departed_at_lt]": data.endDate,
        "q[vessel_loads_destination_type_eq]": data.destination_type,
        domestic: data.isDomestic,
        "q[workflow_state_cont]": "approved",
      },
    };
    const url = Endpoint.vesselTrips();
    await axios
      .get(url, config)
      .then((res) => {
        const data = _.get(res, "data", []);
        if (data.length > 0) {
          context.commit("SET_DATA_VOLUMES", { data });
        } else {
          context.commit("NOT_FOUND_VESSEL_TRIP");
        }
      })
      .catch((e) => {
        context.commit("ERROR_VESSEL_TRIP", { error: e });
      })
      .finally(() => {
        context.commit("LOADING_VESSEL_TRIP", { loading: false });
      });
  },
  async getVesselTrip(context, data) {
    context.commit("LOADING_VESSEL_TRIP", { loading: true });
    const config = {
      params: {
        "q[station_id_cont]": data.station_id,
        "q[departed_at_gt]": data.startDate,
        // "q[departed_at_gt]": "15/12/2020",
        "q[departed_at_lt]": data.endDate,
        "q[vessel_loads_destination_type_eq]": data.destination_type,
        domestic: data.isDomestic,
        "q[workflow_state_cont]": "approved",
      },
    };
    const url = Endpoint.vesselTrips();
    await axios
      .get(url, config)
      .then((res) => {
        const data = _.get(res, "data", []);
        if (data.length > 0) {
          context.commit("SUCCESS_VESSEL_TRIP", { data });
        } else {
          context.commit("NOT_FOUND_VESSEL_TRIP");
        }
      })
      .catch((e) => {
        context.commit("ERROR_VESSEL_TRIP", { error: e });
      })
      .finally(() => {
        context.commit("LOADING_VESSEL_TRIP", { loading: false });
      });
  },
  getOilType(context) {
    context.commit("LOADING_VESSEL_TRIP", { loading: true });
    const config = {
      params: {},
    };
    const url = Endpoint.petrolOilTypes();
    axios
      .get(url, config)
      .then((res) => {
        const data = _.get(res, "data", []);
        if (data.length > 0) {
          context.commit("SET_DATA_OIL_TYPE", { data });
        }
      })
      .catch((e) => {
        context.commit("ERROR_VESSEL_TRIP", { error: e });
      })
      .finally(() => {
        context.commit("LOADING_VESSEL_TRIP", { loading: false });
      });
  },
  getStationDataByDate: (context, value) => {
    let data = _.chain(state.data)
      .map((o) => {
        if (
          o.station_id == value.id &&
          moment(o.departed_at).format("DD/MM/YYYY") == value.date
        ) {
          return o;
        } else {
          return "";
        }
      })
      .value();
    context.commit("SET_DATA_BY_DATE", data);
  },
  async getEventNotificationsData(context) {
    context.commit("LOADING_VESSEL_TRIP", { loading: true });
    const config = {
      params: {
        truck_trips: false,
        vessel_trips: true,
        // limit: 100
      },
    };
    const url = Endpoint.petrolNotifications();
    await axios
      .get(url, config)
      .then((res) => {
        const data = _.get(res, "data", []);
        if (data.length > 0) {
          context.commit("SET_DATA_NOTIFICATION", { data });
        }
      })
      .catch((e) => {
        context.commit("ERROR_VESSEL_TRIP", { error: e });
      })
      .finally(() => {
        context.commit("LOADING_VESSEL_TRIP", { loading: false });
      });
  },
  async markEventNotificationsAsRead(context, id) {
    context.commit("LOADING_VESSEL_TRIP", { loading: true });
    // console.log(id);
    const params = new URLSearchParams({
      id: id,
    }).toString();
    const url = Endpoint.petrolMarkEventNotificationsAsRead() + "?" + params;
    await axios
      .post(url)
      .then((res) => {
        const data = _.get(res, "data", []);
        if (data.length > 0) {
          context.commit("MARK_EVENT_NOTIFICATIONS_AS_READ", { data });
        }
      })
      .catch((e) => {
        context.commit("ERROR_VESSEL_TRIP", { error: e });
      })
      .finally(() => {
        context.commit("LOADING_VESSEL_TRIP", { loading: false });
      });
  },
  async markAllEventNotificationsAsRead(context) {
    context.commit("LOADING_VESSEL_TRIP", { loading: true });
    const url = Endpoint.petrolMarkAllEventNotificationsAsRead();
    await axios
      .post(url)
      .then((res) => {
        const data = _.get(res, "data", []);
        if (data.length > 0) {
          context.commit("MARK_ALL_EVENT_NOTIFICATIONS_AS_READ", { data });
        }
      })
      .catch((e) => {
        context.commit("ERROR_VESSEL_TRIP", { error: e });
      })
      .finally(() => {
        context.commit("LOADING_VESSEL_TRIP", { loading: false });
      });
  },
};

const mutations = {
  UPDATE_VESSEL_TRIP(state, payload) {
    state.data = {
      ...payload,
      ...state.data,
    };
  },
  SUCCESS_VESSEL_TRIP(state, payload) {
    state.data = payload.data;
  },
  ERROR_VESSEL_TRIP(state, payload) {
    state.error = {
      ...payload,
    };
  },
  LOADING_VESSEL_TRIP(state, payload) {
    state.loading = payload.loading;
  },
  NOT_FOUND_VESSEL_TRIP(state) {
    state.data = [];
    state.dataVolume = [];
  },
  SET_CURRENT_REFINERY_ID(state, data) {
    state.currentRefineryID = data;
  },
  SET_CURRENT_REFINERY_NAME(state, data) {
    state.currentRefineryName = data;
  },
  SET_DATA_VOLUMES(state, payload) {
    state.dataVolume = payload.data;
  },
  SET_DATA_OIL_TYPE(state, payload) {
    state.oilType = payload.data;
  },
  SET_BAR_VOLUME(state, payload) {
    state.barValueData = payload.data;
  },
  SET_DATA_BY_DATE(state, data) {
    state.dataByDate = data;
  },
  SET_DATA_NOTIFICATION(state, payload) {
    state.notificationData = payload.data;
  },
  MARK_ALL_EVENT_NOTIFICATIONS_AS_READ(state, payload) {
    state.notificationData = payload.data;
  },
  MARK_EVENT_NOTIFICATIONS_AS_READ(state, payload) {
    state.notificationData = payload.data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
